import { CartStore } from '@/types/stores/cart/cart.store';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useCartStore = create<CartStore>()(
  persist(
    (set, get) => ({
      // Initial state
      items: [],
      totalPrice: { amount: 0, currency: 'SEK' },

      calculateTotalPrice: (items) => {
        return items.reduce((totalPrice, item) => ({ ...totalPrice, amount: totalPrice.amount + item.total.amount }), {
          amount: 0,
          currency: 'SEK',
        });
      },

      addItem: (item) => {
        const items = get().items;
        const existingItem = items.find((i) => i.id === item.id);

        if (existingItem) {
          const updatedItems = items.map((i) =>
            i.id === item.id
              ? {
                  id: item.id,
                  name: item.name,
                  tagline: item.tagline,
                  price: item.price,
                  quantity: i.quantity + 1,
                  total: { ...i.total, amount: (i.quantity + 1) * i.price.amount },
                  thumbnail: item.thumbnail,
                }
              : i,
          );
          set({
            items: updatedItems,
            totalPrice: get().calculateTotalPrice(updatedItems),
          });
        } else {
          const newItem = {
            id: item.id,
            name: item.name,
            tagline: item.tagline,
            price: item.price,
            quantity: 1,
            total: item.price,
            thumbnail: item.thumbnail,
          };
          const updatedItems = [...items, newItem];
          set({
            items: updatedItems,
            totalPrice: get().calculateTotalPrice(updatedItems),
          });
        }
      },

      removeItem: (productId) => {
        const items = get().items;
        const updatedItems = items.filter((item) => item.id !== productId);
        set({
          items: updatedItems,
          totalPrice: get().calculateTotalPrice(updatedItems),
        });
      },

      updateQuantity: (productId, quantity) => {
        const items = get().items;
        const updatedItems = items.map((item) =>
          item.id === productId
            ? { ...item, quantity, total: { ...item.total, amount: quantity * item.price.amount } }
            : item,
        );
        set({
          items: updatedItems,
          totalPrice: get().calculateTotalPrice(updatedItems),
        });
        if (quantity <= 0) set({ items: updatedItems.filter((item) => item.id !== productId) }); // Remove item after 2 seconds
      },

      clearCart: () => {
        set({ items: [], totalPrice: { amount: 0, currency: 'SEK' } });
      },
    }),
    {
      name: 'cart-storage', // The name of the storage key in localStorage
    },
  ),
);

export default useCartStore;
